var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2Vendor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2054 2052",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.751499,0,0,1.00191,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.36394,0,0,1.30127,-525.484,-305.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2085.24,1654.48C2213.93,1654.61 2258.29,1599.54 2258.41,1480.44C2258.68,1226.61 2255.99,829.395 2255.05,576.496C2254.58,449.77 2205.83,388.405 2028.18,389.067C1594.59,390.682 968.61,393.014 689.316,394.054C601.848,394.38 514.745,452.528 515.121,553.736C515.817,740.874 518.896,1327.74 518.697,1515.82C518.617,1591.71 572.277,1652.88 648.578,1652.96C926.008,1653.25 1751.21,1654.12 2085.24,1654.48Z",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "85.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.32001,-0.0260346,0.0344434,0.997752,-9.22544,-158.704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.17,643.475L1921.1,690.284",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "100.4px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.604654,0.650724,-1.15664,0.604654,2175.88,-184.609)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.940521,-0.706062,0.941335,0.705452,-1019.5,1019.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.519,1564.58L560.441,1300.32C560.441,1300.32 1023.57,838.442 1131.97,734.422C1252.19,619.049 1449.76,811.711 1327.41,933.989C1213.82,1047.52 748.055,1513.01 748.055,1513.01L484.519,1564.58Z",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "94.56px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33014,-0.00704737,0.00939215,0.998066,-7.43792,4.90141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.385,822.759L832.894,824.74",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "94.58px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.521872,0.264227,-0.757197,0.820722,469.264,-560.149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.385,822.759L832.894,824.74",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "121.43px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.521872,0.264227,-0.757197,0.820722,-147.281,103.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.385,822.759L832.894,824.74",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: "121.43px"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Vendor);
export default __webpack_public_path__ + "static/media/step2Vendor.f71d579df2a27eaccaf305bb87bb9c1c.svg";
export { ForwardRef as ReactComponent };